import { createId } from "@paralleldrive/cuid2";
/**
 * Factory for creating TopicAssignment instances
 */
export class TopicAssignmentFactory {
    static create(data, id) {
        const now = new Date();
        return {
            id: id || createId(),
            playerId: data.playerId,
            studentName: data.studentName,
            topicId: data.topicId,
            topicTitle: data.topicTitle,
            teacherId: data.teacherId,
            teacherName: data.teacherName,
            lectureId: data.lectureId,
            classroomId: data.classroomId,
            year: data.year,
            term: data.term,
            assignedAt: data.assignedAt,
            isActive: data.isActive !== undefined ? data.isActive : true,
            totalPuzzles: data.totalPuzzles || 0,
            quizPersonalBest: data.quizPersonalBest || 0,
            quizAttempts: data.quizAttempts || 0,
            puzzleAttempts: data.puzzleAttempts || 0,
            completedPuzzles: data.completedPuzzles || 0,
            completedPuzzleIds: data.completedPuzzleIds || [],
            videoWatchCount: data.videoWatchCount || 0,
            createdAt: now,
            updatedAt: now,
        };
    }
}
